import React from "react";
import {Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";

function HeaderUnauthenticated(props: { title: string }) {
  const {title} = props;
  const headerImage = title ?
    <img className="logoVilla" src="/villa.png" width="64" height="64" alt=""/>
    : <Spinner animation="border"/>;


  return (
    <section className="container px-0 rounded">
      <nav className="navbar navbar-dark mt-3">
        <Link to="/">
          <div className="navbar-brand">
            <h3>{headerImage}{title}</h3>
          </div>
        </Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"/>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto pt-4 text-right">
            <li className="nav-item pb-3">
              <Link to="/terms">
                <span>Terms of Use</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/privacy">
                <span>Privacy Policy</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <a href="https://www.villa.rocks">
                <span>Villa Rocks</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  );
}

export default HeaderUnauthenticated;
